import { Skeleton } from "antd"

import styles from "./program-card.module.less"

const ProgramCardSkeleton = () => (
  <div className={styles.card}>
    <div className={styles.skNameRow}>
      <Skeleton.Button active style={{ width: 130, height: 18 }} />
      <Skeleton.Button active style={{ width: 72, height: 26, borderRadius: 6 }} />
    </div>

    <div className={styles.skPrices}>
      <Skeleton.Button active style={{ width: 180, height: 20 }} />
      <Skeleton.Button active style={{ width: 180, height: 20 }} />
    </div>

    <div className={styles.skDesc}>
      <Skeleton.Button active block style={{ height: 14 }} />
      <Skeleton.Button active style={{ width: 260, height: 14 }} />
    </div>

    <div className={styles.divider} />

    <div className={styles.skChars}>
      {[0, 1, 2, 3].map((i) => (
        <div key={i} className={styles.skCharRow}>
          <Skeleton.Button active style={{ width: 110, height: 14 }} />
          <Skeleton.Button active style={{ width: 80, height: 14 }} />
        </div>
      ))}
    </div>

    <Skeleton.Button active block style={{ height: 40, borderRadius: 8, marginTop: 16 }} />
  </div>
)

export default ProgramCardSkeleton
